import initialState from './initialState'

const SET_DATE = function(state, payload) {
    state.date = payload
}

const SET_CASH_AMOUNT = function(state, payload) {
    state.cashAmount = payload
}

const SET_COMMENT = function(state, payload) {
    state.comment = payload
}

const SET_ARQUEO_DATA = function(state, payload) {
    state.arqueoData = payload
}


const SET_INITIAL_SUMMARIES = function(state, payload) {
    state.initialSummaries = payload
}


const SET_INVOICES_DATA = function(state, payload) {
    state.invoicesData = payload.data
}


const RESET_STATE = function(state) {
    state.date= null
    state.cashAmount= null
    state.comment= null
    //state.reason= null
    state.showModal= false
}

export default {
    SET_DATE,
    SET_CASH_AMOUNT,
    SET_COMMENT,
    SET_ARQUEO_DATA,
    SET_INVOICES_DATA,
    SET_INITIAL_SUMMARIES,
    RESET_STATE,

}
